import React from 'react';

const ExpandRightArrow = ({ onClick }: { onClick?: () => void }) => {
  return (
    <button className="button--icon sml border-0" onClick={onClick}>
      <i className="material-symbols-outlined">arrow_right</i>
    </button>
  );
};

export default ExpandRightArrow;
